import { ref } from 'vue';

export interface ConfirmDeleteOptions {
  title?: string;
  message?: string;
  onConfirm: () => Promise<void> | void;
}

export function useConfirmDelete() {
  const isOpen = ref(false);
  const title = ref('Xác nhận xoá');
  const message = ref('Bạn có chắc chắn muốn xoá mục này?');
  const isLoading = ref(false);
  let confirmCallback: (() => Promise<void> | void) | null = null;

  const open = (options: ConfirmDeleteOptions) => {
    title.value = options.title || 'Xác nhận xoá';
    message.value = options.message || 'Bạn có chắc chắn muốn xoá mục này?';
    confirmCallback = options.onConfirm;
    isOpen.value = true;
  };

  const confirm = async () => {
    if (confirmCallback) {
      isLoading.value = true;
      try {
        await Promise.resolve(confirmCallback());
      } finally {
        isLoading.value = false;
        isOpen.value = false;
      }
    }
  };

  const cancel = () => {
    isOpen.value = false;
    confirmCallback = null;
  };

  return {
    isOpen,
    title,
    message,
    isLoading,
    open,
    confirm,
    cancel,
  };
}
